import './App.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Routes } from './utils/Routes';
import Home from './pages/Home';
import About from './pages/About';
import Art from './pages/Art';
import UnspokenArtDetails from './pages/ArtDetails';
import Things from './pages/Things';
import ThingDetails from './pages/ThingDetails';
import Thoughts from './pages/Thoughts';
import Info from './pages/Info';
import Music from './pages/Music';
import ThoughtDetails from './pages/ThoughtDetails';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import StandaloneThoughtView from './pages/StandaloneThoughtView';
import ArtPublication from './pages/ArtPublication';
import ErrorFallback from './components/common/ErrorFallback';

const router = createBrowserRouter([
  {
    path: Routes.Home,
    element: <Home />,
  },
  {
    path: Routes.About,
    element: <About />,
  },
  {
    path: Routes.Art,
    element: <Art />,
  },
  {
    path: Routes.ArtPublication,
    element: <ArtPublication />,
  },
  {
    path: `${Routes.Art}/:id`,
    element: <UnspokenArtDetails />,
  },
  {
    path: Routes.Things,
    element: <Things />,
  },
  {
    path: `${Routes.Things}/:id`,
    element: <ThingDetails />,
  },
  {
    path: Routes.Thoughts,
    element: <Thoughts />,
  },
  {
    path: `${Routes.Thoughts}/:id/view`,
    element: <StandaloneThoughtView />,
  },
  {
    path: `${Routes.Thoughts}/:id`,
    element: <ThoughtDetails />,
    errorElement: <ErrorFallback />,
  },
  {
    path: `${Routes.ThoughtInfo}`,
    element: <Info />,
  },
  {
    path: Routes.Music,
    element: <Music />,
  },
  {
    path: Routes.Thoughts,
    element: <Thoughts />,
  },
  {
    path: Routes.Contact,
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
